import React, { useEffect, useState } from 'react';
import './longest-word.css';

const ALPHA = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export interface LongestWordLetterRowProps {
  /** Target letters (length 10). Used when frozen. */
  letters: string;
  /** When true, tiles roll through random A–Z. */
  rolling?: boolean;
  className?: string;
  /** Larger host-style tiles. */
  size?: 'host' | 'player';
}

/**
 * Ten letter tiles — roll during bonus intro, freeze to payload letters for play.
 */
export const LongestWordLetterRow: React.FC<LongestWordLetterRowProps> = ({
  letters,
  rolling = false,
  className,
  size = 'host',
}) => {
  const frozen = (letters ?? '').toUpperCase().replace(/[^A-Z]/g, '').padEnd(10, '?').slice(0, 10);
  const [display, setDisplay] = useState(() =>
    rolling ? Array.from({ length: 10 }, () => ALPHA[Math.floor(Math.random() * 26)]) : frozen.split('')
  );

  useEffect(() => {
    if (!rolling) {
      setDisplay(frozen.split(''));
      return;
    }
    const id = window.setInterval(() => {
      setDisplay((prev) =>
        prev.map((_, i) => {
          // Stagger: each column advances on its own tick feel
          if (Math.random() > 0.45) return ALPHA[Math.floor(Math.random() * 26)];
          return prev[i];
        })
      );
    }, 90);
    return () => window.clearInterval(id);
  }, [rolling, frozen]);

  return (
    <div
      className={`longest-word-letter-row longest-word-letter-row--${size}${className ? ` ${className}` : ''}${
        rolling ? ' longest-word-letter-row--rolling' : ''
      }`}
      aria-label={rolling ? 'Letters randomizing' : frozen.split('').join(' ')}
      aria-live={rolling ? 'off' : 'polite'}
    >
      {display.map((ch, i) => (
        <span key={i} className="longest-word-letter-tile">
          {ch}
        </span>
      ))}
    </div>
  );
};
